import { Loader } from '../../../../../../../../components/loader/loader';
import { DeleteModal } from '../../../../../../../../features/delete-modal/delete-modal';
import { EditableLabel } from '../../../../../../../../features/editable-label/editable-label';
import { Sorter } from '../../../../../../../../features/sorter/sorter';
import { useMenuInformerCreateSectionsModal } from '../../../menu-informer-table/menu-informer-table-header/menu-informer-create-section-modal/use-menu-informer-create-sections-modal';
import { MenuInformerCreateUnit } from '../../../menu-informer-table/menu-informer-table-header/menu-informer-create-unit';
import s from './menu-informer-create-menu-modal-step-2.module.css';

export const MenuInformerCreateMenuModalStep2 = () => {
  const {
    deleteSection,
    handleCreate,
    handleUpdate,
    isLoading,
    language,
    sections,
    setSectionListOrder,
    getLocale,
    t,
    addQueryParams,
  } = useMenuInformerCreateSectionsModal();

  return (
    <div className={s.feature}>
      {isLoading && <Loader />}
      <MenuInformerCreateUnit
        placeholder={t('Например, «Бар» или «Кухня»')}
        name="section"
        onConfirm={handleCreate}
        showLanguageSelect={false}
        isLoading={isLoading}
        data-testid="create-unit"
      />
      <ul className={s.inputs}>
        <Sorter
          itemIds={sections.map((item) => item.id)}
          onSort={(e) => setSectionListOrder(e.map(Number))}
        >
          {sections?.map((section) => (
            <EditableLabel
              key={section.id}
              className={s.item}
              sortable
              id={section.id}
              onDelete={async () => {
                addQueryParams({
                  deleteId: section.id.toString(),
                  deleteName: getLocale(section.name, language),
                });
              }}
              value={getLocale(section.name, language)}
              onConfirm={(e) =>
                handleUpdate({ ...section, name: { ...section.name, [language]: e } })
              }
              data-testid={`category-${section.id}`}
            >
              {getLocale(section.name, language)}
            </EditableLabel>
          ))}
        </Sorter>
      </ul>
      <DeleteModal onSubmit={deleteSection} />
    </div>
  );
};
